import React from "react";
import { Button, Type } from "mesh-component-library";
import { datadogRum } from "@datadog/browser-rum";
import { useLocale } from "../../../../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../../../../app-consts/translations";

type ErrorProps = {
  onClick: () => void;
};

export const NoNearbyPepDestinationError = ({ onClick }: ErrorProps) => {
  const getTranslatedText = useLocale();
  return (
  <div style={{ display: "flex", flexDirection: "column", padding: "1rem" }}>
    <Type size="lg" weight="bold" style={{ paddingTop: "3rem", paddingBottom: "8px" }} data-testid="listView-pepDestinationError-heading">
      {getTranslatedText(TRANSLATION_CONSTANTS.NO_PEP_BOYS_NEARBY)}
    </Type>
    <Type style={{ paddingBottom: "6rem" }}>
      {getTranslatedText(TRANSLATION_CONSTANTS.NO_PEP_BOYS_IN_COVERED_MILEAGE)}
    </Type>
    <Button hasUpgrade style={{ marginBottom: "16px" }} onClick={onClick} data-testid="listView-pepDestinationError-call">
      {getTranslatedText(TRANSLATION_CONSTANTS.CALL_FOR_HELP)}
    </Button>
  </div>
)};

export const GenericNoNearbyDestinationError = ({ onClick }: ErrorProps) => {
  const getTranslatedText = useLocale();
  const handleReloadClick = () => {
    datadogRum.addAction("[ListView - noNearbyDestinationError] User clicked reload");
    location.reload();
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "1rem" }}>
      <Type size="lg" weight="bold" style={{ paddingBottom: "8px" }} data-testid="listView-destinationError-heading">
        {getTranslatedText(TRANSLATION_CONSTANTS.SOMETHING_WENT_WRONG)}
      </Type>
      <Type style={{ paddingBottom: "6rem" }}>
        {getTranslatedText(TRANSLATION_CONSTANTS.REPAIR_CENTERS_LOAD_ERROR)}
      </Type>
      <Button hasUpgrade style={{ marginBottom: "16px" }} onClick={handleReloadClick} data-testid="listView-destinationError-reload">
        {getTranslatedText(TRANSLATION_CONSTANTS.RELOAD_THE_PAGE)}
      </Button>
      <Button hasUpgrade variant="muted" onClick={onClick} data-testid="listView-destinationError-call">
        {getTranslatedText(TRANSLATION_CONSTANTS.CALL_FOR_HELP)}
      </Button>
    </div>
  );
};
